// extracted by mini-css-extract-plugin
export default {"icon":"ContactSupportModal_icon__EFpiJ"};